<template>
    <div name="post" class="post">
        <div class="contents" v-if="state===0">  
            <span class="title">1형 당뇨인 불편접수함</span>
            <span class="description" style="margin-top: 16px;">남겨주신 의견을 바탕으로 하나씩 개선하고 있습니다.<br>작은 불편함이든 큰 불편함이든, 불편한 순간이 생각 나셨다면 꼭 의견을 남겨주세요.</span>
            <div class="line"></div>
            <div class="row" style="align-items: center;">
                <span>1형당뇨</span>
                <input 
                    type="text"
                    inputmode="numeric"
                    maxlength="2"
                    v-focus-input-style
                    class="input"
                    ref="yearCount"
                    v-model="yearCount"
                    placeholder="숫자만 입력"
                />
                <span>년차</span>
            </div>
            <span style="margin-left: 81px; margin-top: 4px;" class="error_message">{{ yearCountError }}</span>
            <div class="wrapper">
                <textarea
                    :placeholder="placeholder"
                    class="textarea"
                    v-model="contents"
                    v-focus-input-style
                    ref="contents"
                >
                </textarea>
                <span class="text-count"><span :style="contents.length > 0 ? 'color: var(--Blue-01_Primary-blue, #008DEF)' : ''">{{ contents.length }}</span>/200</span>
            </div>

            <div class="row" style="margin-top: 8px;">
                <img class="icon" src="../../../assets/warning2.png" />
                <div class="col" style="margin-left: 4px;">
                    <span class="info-text">등록 후에는 수정, 삭제가 불가능합니다.</span>
                    <span class="info-text">200자 이내로 작성해 주세요.</span>
                </div>
            </div>
            <span style="margin-top: 4px;" class="error_message">{{ contentsError }}</span>
            <div class="row" style="justify-content: flex-end;margin-top: 16px;">
                <div class="cancel-button" @click="close">
                    취소
                </div>
                <div class="submit-button" style="margin-left: 20px;" @click="submit">
                    불편 접수하기
                </div>
            </div>
            
        </div>
        <div class="cancel" v-else-if="state===1">
            <span class="cancel_text1">작성중인 내용이 있습니다.</span><br>
            <span class="cancel_text2">이대로 나가시면 소중한 내용이 사라질 수 있어요.<br>그래도 나가시겠어요?</span>
            <div class="row" style="justify-content: flex-end;margin-top: 60px;">
                <div class="cancel-button" style="width: 98px;" @click="cancelClose">
                    아니요
                </div>
                <div class="submit-button" style="margin-left: 20px;width: 134px;" @click="closeForce">
                    네, 나갈게요
                </div>
            </div>
        </div>
        <div class="submit" v-else>
            <img style="width: 118px;" src="../../../assets/crap.png" />
            <span class="submit_title" style="margin-top: 20px;">소중한 의견을 남겨주셔서 감사합니다!</span>
            <span class="submit_description" style="margin-top: 16px;">오늘 남겨주신 의견을 바탕으로</span>
            <span class="submit_description">1형 당뇨인을 위한 더 나은 미래를 만들어가겠습니다.</span>
            <div class="submit-button" style="width: 84px; margin-top: 40px;" @click="onSubmit">
                확인
            </div>
        </div>
    </div>
</template>

<script>
import focusInputStyle from '@/components/directives/focusInputStyle';
import Constant from '@/constant';
import {mapState} from 'vuex'
import Convert from '@/utilities/convert'

export default {
    name: 'post',
    computed: mapState(['vocDiabetes']),
    data: function()
    {
        return {
            placeholder: `솔닥 컨시어지 사용 여부와 상관 없이 자유롭게 알려주세요. 

여러분이 들려주신 불편함이
다른 누군가의 평범한 일상을 되찾는 실마리가 될 수 있습니다. 
            
솔닥 컨시어지는 해결할 수 있는 방법을 끝까지 찾아보겠습니다.`,
            yearCount: null,
            contents: '',
            state: 0,
            yearCountError: '',
            contentsError: ''
        }
    },
    mounted: function()
    {
        // scroll 삭제
            document.body.style.overflow = 'hidden'; // 스크롤 비활성화
    },
    directives: {
        focusInputStyle
    },
    methods: {
        close: function()
        {
            if(this.contents !== '')
            {
                this.state = 1;
            }
            else
            {
                document.body.style.overflow = ''; // 스크롤 활성화
                this.$emit('onClose')
            }
        },
        cancelClose: function()
        {
            this.state = 0;
        },
        onSubmit: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('onSubmit')
        }, 
        closeForce: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('onClose')
        },
        submit: function()
        {

            if(this.yearCount === undefined || this.yearCount === null || this.yearCount === '')
            {
                this.errorFocus('yearCount')
                this.yearCountError = '내용을 입력해 주세요.'
                return;
            }

            if(!Convert.isNumeric(this.yearCount))
            {
                this.errorFocus('yearCount')
                this.yearCountError = '숫자를 입력해 주세요.'
                return;
            }


            if(this.contents.length > 200)
            {
                this.errorFocus('contents')
                this.contentsError = '200자 이내로 작성해 주세요.'; 
                return;
            }

            if(this.contents.trim() === '')
            {
                this.errorFocus('contents')
                this.contentsError = '내용을 입력해 주세요.'; 
                return;
            }

            if(this.contents === undefined || this.contents === null || this.contents === '' )
            {
                this.errorFocus('contents')
                this.contentsError = '내용을 입력해 주세요.'; 
                return;
            }


            this.$store.commit(Constant.INITIALIZE_DIABETES_VOC)
            this.vocDiabetes.contents = this.contents;
            this.vocDiabetes.yearCount = this.yearCount;
            this.$store.dispatch(Constant.ADD_DIABETES_VOC)
                .then((res) => {
                    this.state = 2;
                })
                .catch((err) => {
                    
                })
                
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
    },
    watch: {
        yearCount: function()
        {
            if(!Convert.isNumeric(this.yearCount))
            {
                this.yearCount = this.yearCount.replace(/[^0-9]/g, "");
            }
            this.yearCountError = '';
        },
        contents: function()
        {
            if(this.contents.length > 200)
            {
                this.contentsError = '200자 이내로 작성해 주세요.';
                this.errorFocus('contents') 

            }
            else {
                this.contentsError = '';
            }
        }
    }
}
</script>

<style scoped>
    .post {
        position: fixed;
        width: 100%;
        height: 100vh;
        background: rgba(167, 167, 167, 0.76);
        left: 0;
        top: 0;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .contents {
        width: 719px;
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 40px;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 120% */
    }
    .description {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    .line {
        width: 100%;       
        height: 1px;
        background: #E8EAEE;
        margin: 32px 0;
    }

    .input {
        width: 112px;
        height: 40px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 16px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
        border: 0;
        margin-left: 32px;
        margin-right: 8px;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .textarea {
        width: 100%;
        height: 135px;       /* 원하는 높이 */
        resize: none;        /* 크기 조절 비활성화 */
        overflow-y: auto;    /* 내용이 넘치면 스크롤 */
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        border: 0;
        margin-top: 32px;
        padding: 12px 16px;
        box-sizing: border-box;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    textarea::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .icon {
        width: 22px;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

    }
    .col {
        display: flex;
        flex-direction: column;
    }
    .info-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    .cancel-button {
        display: flex;
        height: 48px;
        width: 84px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        cursor: pointer;
    }
    .submit-button {
        display: flex;
        height: 48px;
        width: 143px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        cursor: pointer;
    }

    .cancel {
        width: 485px;
        height: 268px;
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 40px;
    }
    .cancel_text1 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .cancel_text2 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
    }
    .submit {
        display: flex;
        width: 434px;
        height: 421px;
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 40px;
        justify-content: flex-start;
        align-items: center;
    }
    .submit_title {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 120% */
    }
    .submit_description{
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    .error_message {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    .wrapper {
        width: 100%;
        position: relative;
    }
    .text-count {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        position: absolute;
        bottom: 12px;
        right: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/pc_uncomfortable/Post.vue